import { FeatureFlag } from '../FeatureFlag';

export const enableLabRiskSettings = new FeatureFlag({
    key: 'enable-lab-risk-settings',
    createdOn: '2026-08-10',
    defaultValue: false,
});
